import React, {useEffect} from 'react';
import CompositeReportState from 'main/containers/reports/state/CompositeReportState';
import {observer} from 'mobx-react';
import ReportFilter from './ReportFilter';

const CompositeReport = observer(({children, uiState}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    uiState.applyFilters();
  }, []);

  return (
    <div>
      <ReportFilter uiState={uiState}/>
      {React.Children.map(children, child => child ? React.cloneElement(child, {uiState}) : null)}
    </div>
  );
});

const CompositeReportWithState = ({children, filters, dateFilter, dateFilterFormat, defaultStartDate, defaultEndDate, filterRows, disableFilterEditing}) => {
  const uiState = new CompositeReportState(filters, dateFilter, dateFilterFormat, defaultStartDate, defaultEndDate, filterRows, disableFilterEditing);

  return (
    <CompositeReport uiState={uiState}>
      {children}
    </CompositeReport>
  );
};

export default CompositeReportWithState;
